import "./ModalCancelPolicy.css";

import { Colors, Icon } from "swing-components";

import { translate } from "~utils";

type ModalCancelPolicyProps = {
  onDismiss: () => void;
};

export function ModalCancelPolicy(props: ModalCancelPolicyProps) {
  const { onDismiss } = props;

  return (
    <div className="modal-wrapper" style={{ paddingTop: 0, paddingBottom: 0 }}>
      <div className="modal-header">
        <h2 className="modal-header-label">{translate("CANCEL_POLICY_LABEL")} </h2>
        <button onClick={onDismiss} style={{ backgroundColor: "transparent" }}>
          <Icon name="Close" color={Colors.blue500} />
        </button>
      </div>

      <div
        css={{
          flexDirection: "column",
          paddingLeft: 16,
          paddingRight: 16,
        }}
      >
        <div
          className="modal-subheading"
          css={{ marginBottom: 24 }}
          dangerouslySetInnerHTML={{
            __html: translate("CANCEL_POLICY_MODAL_SUBHEADING"),
          }}
        />
        <CancelPolicyIconBlock
          color={Colors.yellow500}
          label={translate("CANCEL_POLICY_MODAL_YELLOW_LABEL")}
          body={translate("CANCEL_POLICY_MODAL_YELLOW_BODY")}
        />
        <CancelPolicyIconBlock
          color={Colors.red500}
          label={translate("CANCEL_POLICY_MODAL_RED_LABEL")}
          body={translate("CANCEL_POLICY_MODAL_RED_BODY")}
        />
      </div>
    </div>
  );
}

function CancelPolicyIconBlock({
  color,
  label,
  body,
}: {
  color: string;
  label: string;
  body: string;
}) {
  return (
    <div css={{ flexDirection: "row", display: "flex", marginBottom: 24 }}>
      <div
        css={{
          width: 12,
          minWidth: 12,
          flexShrink: 0,
          borderRadius: 8,
          backgroundColor: color,
        }}
      />
      <div css={{ marginLeft: 16 }}>
        <div className="label">{label}</div>
        <div dangerouslySetInnerHTML={{ __html: body }} />
      </div>
    </div>
  );
}
